import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppyProfessional } from 'src/app/core/model/v2/AppyProfessional';
import { PracticeService } from 'src/app/core/services/v2/practice.service';
import { UserService } from 'src/app/core/services/v2/user.service';

@Component({
  selector: 'app-managed-professionals',
  templateUrl: './managed-professionals.component.html',
  styleUrls: ['./managed-professionals.component.scss']
})
export class ManagedProfessionalsComponent implements OnInit {
professionals: AppyProfessional[];
displayedColumns: string[] = ['name', 'role', 'practitionerSpeciality' , 'hsNames' ];

getDisplayedColumns():string[] 
{
  // if (this.practiceService.currentUserGlobalAdministrator())
  //   return this.displayedColumns.concat(['isGlobalAdmin']);

  return this.displayedColumns;
}

  constructor(private router:Router, private userService :UserService, private practiceService : PracticeService) { }

  ngOnInit() {

    this.userService.getAllProfessionalsManagedByUser().subscribe( userProfessionals => this.professionals = userProfessionals );
  }

  redirectToProfile(practitionerId:number)
  {
    if(practitionerId >0)
      this.router.navigate(['/physician/profile', { id: practitionerId}]);

  }

  ToogleAsGlobalAdmin(professional : AppyProfessional)
  {
      if(professional.IsGlobalAdministrator)
      {
        var msg = `Do you want remove ${professional.name} Global Administrator status?`;
        //ask confirmation      
        // post to User/{userID}/ToogleIsGlobalAdministratorFlag
      }else{
        var msg = `Do you want give ${professional.name} Global Administrator status?`;
                //ask confirmation      
        // post to User/{userID}/ToogleIsGlobalAdministratorFlag
      }
  }

}
